import { Button, Input, Select } from "@deligoo/ui"
import { ChangeEvent, Dispatch, SetStateAction, useEffect, useState } from "react"
import { shallowEqual } from "react-redux"
import { useHistory } from "react-router-dom"

import { useAppSelector } from "@/App"
import { selectCurrentTeamStats } from "@/store/teamsStats"
import { Client, TransportType } from "@/types"
import { escapeRegex } from "@/utils/utils"

import cls from "../ClientsListView.module.scss"

type HeaderProps = {
  isGlobal: boolean
  setFilters: Dispatch<SetStateAction<((client: Client) => boolean)[]>>
  setIsGlobal: Dispatch<SetStateAction<boolean>>
}

export const Header = ({ isGlobal, setIsGlobal, setFilters }: HeaderProps) => {
  const [searchFilter, setSearchFilter] = useState("")
  const [paramsFilter, setParamsFilter] = useState("")

  const currentTeamStats = useAppSelector(selectCurrentTeamStats, shallowEqual)

  const history = useHistory()

  useEffect(() => {
    setFilters([
      (client) => {
        if (paramsFilter === "own_delivery") {
          return client.own_delivery
        }

        if (paramsFilter && ["bicycle", "scooter"].includes(paramsFilter)) {
          return client.transport_types.includes(paramsFilter as TransportType)
        }

        if (paramsFilter === "unsettled_payments") {
          return currentTeamStats?.unsettled_payments_ids.includes(client.id) || false
        }

        return true
      },

      (client) => {
        if (!searchFilter) return true

        const searchValues = escapeRegex(searchFilter).trim().split(" ")
        const regExps = searchValues.map((searchValue) => new RegExp(searchValue, "i"))

        return regExps.every(
          (regex) => regex.test(client.name) || regex.test(client.address) || regex.test(client.phone)
        )
      },
    ])
  }, [paramsFilter, searchFilter, setFilters, currentTeamStats])

  useEffect(() => {
    if (window.location.pathname.includes("nierozliczone")) {
      history.push("/lokalizacje")
      setParamsFilter("unsettled_payments")
    }
  }, [history])

  return (
    <div className={cls.header}>
      <h1 className="text-light h400">Lokalizacje</h1>
      <Input
        placeholder="Szukaj"
        iconRightProps={{ name: "search", color: "primary" }}
        onChange={(e: ChangeEvent<HTMLInputElement>) => setSearchFilter(e.target.value)}
        plain
        dark
      />
      <Select
        value={paramsFilter}
        onChange={(e: ChangeEvent<HTMLSelectElement>) => setParamsFilter(e.target.value)}
        dark
      >
        <option value="">Wszystkie</option>
        <option value="bicycle">Obsługiwanie rowerów</option>
        <option value="scooter">Obsługiwanie skuterów</option>
        <option value="own_delivery">Obsługiwanie dostaw własnych</option>
        <option value="unsettled_payments">Nierozliczone płatności</option>
      </Select>

      <Button color="primary" onClick={() => setIsGlobal((isGlobal) => !isGlobal)}>
        {isGlobal ? "Wyłącz lokalizacje globalnie" : "Lokalizacje globalnie"}
      </Button>
    </div>
  )
}
